import styled from "styled-components";

import ContactGroup from "src/shared/contact-boxes/components/ContactGroup";

export const ExpertContainer = styled(ContactGroup)`
  margin: 0 0 24px;
`;
